<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <template slot="controls">
        <el-button @click="getSchema" icon="el-icon-refresh-right">
          {{ $t('Integrations_Magento_Button_FetchMagentoAttributes') }}
        </el-button>
      </template>
      <rest-form-item
        :label="$t('Integrations_Magento_Field_AccessToken')"
        prop="params.accessToken"
        :hint="$t('Integrations_Magento_Field_AccessToken_Hint')"
      >
        <el-input
          v-model="model.params.accessToken"
          :placeholder="$t('Integrations_Magento_Field_AccessToken')"
        />
      </rest-form-item>

      <rest-form-item
        :label="$t('Integrations_Magento_Field_ShopUrl')"
        prop="params.shopUrl"
        :hint="$t('Integrations_Magento_Field_ShopUrl_Hint')"
      >
        <el-input
          v-model="model.params.shopUrl"
          :placeholder="$t('Integrations_Magento_Field_ShopUrl')"
        />
      </rest-form-item>
    </form-section>
    <div>
      <data-mapper
        v-if="
          model.params.hasOwnProperty('mapping') &&
            model.params.mapping.length > 0
        "
        :columns="model.params.mapping"
        :attributes-prop="attributes"
        :fixed-mappings="fixedMappings"
        :filterable-attributes="filterableAttributes"
      />
    </div>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import DataMapper from '@/common/components/DataMapper'

export default {
  name: 'MagentoSettings',
  components: {
    FormSection,
    RestFormItem,
    DataMapper
  },
  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          accessToken: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          shopUrl: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      },
      isLoading: false,
      fixedMappings: {
        group_id: 'magento_group_id',
        created_at: 'magento_created_at',
        updated_at: 'magento_updated_at',
        created_in: 'magento_updated_in',
        gender: 'magento_gender',
        firstname: 'magento_first_name',
        lastname: 'magento_last_name',
        store_id: 'magento_store_id',
        website_id: 'magento_website_id',
        addresses: 'magento_addresses',
        dob: 'magento_dob',
        disable_auto_group_change: 'magento_disable_auto_group_change',
        extension_attributes: 'magento_extension_attributes',
        custom_attributes: 'magento_custom_attributes',
        default_billing: 'magento_default_billing',
        default_shipping: 'magento_default_shipping'
      },
      filterableAttributes: [
        'user_id',
        'email',
        'mobile_number',
        'whatsapp_number',
        'language',
        'timezone',
        'email_addressable',
        'email_subscription',
        'sms_addressable',
        'sms_subscription'
      ],
      attributes: []
    }
  },
  mounted() {
    this.$set(this.model, 'fixedMappings', this.fixedMappings)
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    autoFetchAttributes: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getSchema() {
      this.isLoading = true
      this.$set(this.model.params, 'mapping', [])
      RestApi(
        projectEndpoint({
          method: 'get',
          url: 'integrations/magento/preview',
          params: {
            shopUrl: this.model.params.shopUrl,
            accessToken: this.model.params.accessToken,
            projectId: this.$route.query.project_id
          }
        })
      )
        .then(({ data }) => {
          this.model.params.mapping = data.columns.filter(col => {
            return col.name !== 'customer_id'
          })
          this.fetchAttributes()
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
          this.$message({
            message: this.$t(
              'Integrations_Magento_Button_FetchMagentoAttributesError'
            ),
            type: 'error'
          })
        })
    },
    updateCols() {
      const defaultMapping = {
        id: 'user_id',
        is_subscribed: 'email_subscription',
        email: 'email'
      }
      this.model.params.mapping.forEach(col => {
        if (this.fixedMappings.hasOwnProperty(col.name)) {
          this.$set(col, 'attribute', this.fixedMappings[col.name])
        }
        if (defaultMapping.hasOwnProperty(col.name)) {
          this.$set(col, 'attribute', defaultMapping[col.name])
        } else if (this.attributes.findIndex(e => e.name === col.name) >= 0) {
          this.$set(col, 'attribute', col.name)
        } else if (
          this.filterableAttributes.findIndex(
            e => e.toUpperCase() === col.name.toUpperCase()
          ) >= 0
        ) {
          let attrName = this.filterableAttributes.find(
            e => e.toUpperCase() === col.name.toUpperCase()
          )
          if (!this.isEdit) {
            this.$set(col, 'attribute', attrName)
          }
        }
        if (col.name === 'id') {
          this.$set(col, 'readOnly', true)
        }
      })
    },
    fetchAttributes() {
      let params = { sort: 'title', attribute_profile: 1 }

      RestApi({
        ...this.attributesEndpoint,
        params: params
      })
        .then(({ data }) => {
          this.attributes = data
          this.updateCols()
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  },
  computed: {
    attributesEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `tags`
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/magento/MagentoSettings.vue